import React, { ReactNode, useCallback, useEffect, useRef } from 'react'

import { isServer } from '../../utils'

interface Props {
  children: ReactNode
  onClick: () => void
}

export const ClickOutsideContainer: React.FC<Props> = ({
  children,
  onClick,
}) => {
  const ref = useRef(null)

  const handleOnClick = useCallback(
    (e: Event) =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      !(ref.current! as any).contains(e.target) ? onClick?.() : undefined,
    [onClick],
  )

  useEffect(() => {
    if (!isServer()) {
      window.addEventListener('click', handleOnClick)
    }
    return () => {
      if (!isServer()) {
        window.removeEventListener('click', handleOnClick)
      }
    }
  }, [handleOnClick])

  return <div ref={ref}>{children}</div>
}
